export const GET_CARDS = "GET_CARDS";
export const SAVE_CARD = "SAVE_CARD";
export const DELETE_CARD = "DELETE_CARD";
export const SET_DEFAULT = "SET_DEFAULT";
